module.exports = __webpack_public_path__ + "static/media/pwc.89aa1f27.png";